module.exports = __webpack_public_path__ + "static/media/ic-placeholder.5713baf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-placeholder.svg
// module id = 743
// module chunks = 14